import { render, staticRenderFns } from "./InlineBlock.vue?vue&type=template&id=344e04c9"
import script from "./InlineBlock.vue?vue&type=script&lang=ts"
export * from "./InlineBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports